<app-create-quick-customer-lookup (CustomerId)="close($event)"></app-create-quick-customer-lookup>